<template>
  <div class="teacher-dashboard pa-4">
    <div class="teacher-wrap">
    <div class="d-flex align-center justify-space-between mb-8">
      <div class="d-flex align-center">
        <v-btn icon color="white" to="/akademie" class="mr-4">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div>
          <h2 class="text-h4 font-weight-bold white--text">Teacher Dashboard</h2>
          <div class="grey--text">Übersicht aller Lernenden und deren Fortschritt</div>
        </div>
      </div>
      <v-chip color="blue" text-color="white" class="font-weight-bold">Teacher-Bereich</v-chip>
    </div>

    <v-card dark class="pa-6 rounded-xl" style="background: rgba(30, 30, 30, 0.8)">
      <v-row class="mb-4">
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Name oder Studio suchen..."
            outlined
            dense
            hide-details
            color="#D4AF37"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="tierFilter"
            :items="['Alle', 'Bronze', 'Silber', 'Gold']"
            label="Höchste Stufe"
            outlined
            dense
            hide-details
            color="#D4AF37"
          ></v-select>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="filteredUsers"
        :loading="loading"
        :search="search"
        dark
        class="elevation-0 transparent-bg"
        @click:row="openKartei"
      >
        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center font-weight-bold">
            <v-avatar size="32" color="grey darken-3" class="mr-3">
              <span class="white--text text-caption">{{ item.firstName.charAt(0) }}{{ item.lastName.charAt(0) }}</span>
            </v-avatar>
            {{ item.firstName }} {{ item.lastName }}
          </div>
        </template>
        <template v-slot:item.highestTier="{ item }">
          <v-chip :color="getTierColor(item.highestTier)" small text-color="black" class="font-weight-bold">
            {{ item.highestTier || 'Keine' }}
          </v-chip>
        </template>
        <template v-slot:item.progress="{ item }">
          <div class="d-flex align-center">
            <v-progress-linear :value="item.totalProgress" color="#D4AF37" rounded height="6" class="mr-2" style="width: 80px"></v-progress-linear>
            <span class="text-caption gold-text">{{ item.totalProgress }}%</span>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon color="#D4AF37" @click.stop="openKartei(item)">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "TeacherDashboard",
  data() {
    return {
      users: [],
      loading: false,
      search: "",
      tierFilter: "Alle",
      headers: [
        { text: "Name", value: "name" },
        { text: "Studio", value: "studio" },
        { text: "Rolle", value: "role" },
        { text: "Höchste Stufe", value: "highestTier" },
        { text: "Gesamtfortschritt", value: "progress" },
        { text: "", value: "actions", sortable: false, align: "right" },
      ]
    };
  },
  computed: {
    filteredUsers() {
      if (this.tierFilter === "Alle") return this.users;
      return this.users.filter(u => 
        (u.highestTier && u.highestTier.toLowerCase() === this.tierFilter.toLowerCase()) ||
        (!u.highestTier && this.tierFilter === 'Keine')
      );
    }
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      this.loading = true;
      try {
        const res = await api.akademie.fetchTeacherUserList();
        this.users = res || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    getTierColor(tier) {
      if (!tier) return 'grey';
      const t = tier.toLowerCase();
      if (t === 'bronze') return '#CD7F32';
      if (t === 'silber') return '#C0C0C0';
      if (t === 'gold') return '#FFD700';
      return 'grey';
    },
    openKartei(item) {
      this.$router.push(`/akademie-teacher/user/${item._id || item.id}`);
    }
  }
};
</script>

<style scoped>
.teacher-dashboard {
  min-height: 100vh;
  background-color: #121212;
}
.teacher-wrap {
  max-width: 1400px;
  margin: 0 auto;
}
.transparent-bg {
  background-color: transparent !important;
}
.gold-text {
  color: #D4AF37 !important;
}
.v-data-table :deep(tr) {
  cursor: pointer;
  transition: background-color 0.2s;
}
.v-data-table :deep(tr:hover) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}
</style>
